import React, { FC } from 'react';

import { HomeHeatMap } from './homeHeatMap';
import * as S from './homeMenu.styles';
import { HomeSkin } from './homeSkin';
import { HomeSizes } from './homeSizes';
import { HomeCoverage } from './homeCoverage';

export const HomeMenu: FC = () => {
  return (
    <S.Container>
      <HomeSizes />
      <HomeSkin />
      <HomeCoverage />
      <HomeHeatMap />
    </S.Container>
  );
};
